import { render } from "./TextPanel.vue?vue&type=template&id=21471a16&scoped=true"
import script from "./TextPanel.vue?vue&type=script&lang=js"
export * from "./TextPanel.vue?vue&type=script&lang=js"

import "./TextPanel.vue?vue&type=style&index=0&id=21471a16&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21471a16"]])

export default __exports__